import './HeaderPage.css'
import { HeaderPageContextProvider, createHeaderPageContext } from './HeaderPageContextProvider'
import { DefaultTemplate } from './Templates/DefaultTemplate'

export const HeaderPage = ({ headerPageContext, ...props }) => {
    if (!headerPageContext) headerPageContext = createHeaderPageContext(props)
    
    return <HeaderPageContextProvider value={headerPageContext}>{headerPageContext.render()}</HeaderPageContextProvider>
}
